// MUTATIONS
export const MUTATION_NEW_DECISION_DIALOG               = 'newDecisionDialogMutation'
export const MUTATION_DECISIONS                         = 'setDecisionsMutation'
export const MUTATION_ADD_DECISION                      = 'addDecisionMutation'
export const MUTATION_REMOVE_DECISION                   = 'removeDecisionMutation'
export const MUTATION_UPDATE_DECISION                   = 'updateDecisionMutation'
export const MUTATION_FETCHING_STATUS                   = 'setFetchingStatusMutation'
export const MUTATION_UPDATE_LAST_FETCHED_TIME          = 'updateLasteFetchedTimeMutation'

// ACTIONS
